 (function () {
  'use strict';
  var nativeAlert = window.alert;
  var savedDeliveryFields = [];
  var bypassActive = false;
  function normalize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function isUnavailable() {
    var input = document.getElementById('ogInlineLocationInput');
    var message = document.getElementById('ogInlineMessage');
    if (!input || !message || !String(input.value || '').trim()) return false;
    var text = normalize(message.textContent || '');
    return (
      text.indexOf('delivery is not available') > -1 ||
      text.indexOf('this product cannot be delivered') > -1
    );
  }
  function getDeliveryFields() {
    var selectors = [
      '#og-delivery-widget input',
      '#og-delivery-widget select',
      '#og-delivery-widget textarea',
      '#ogPropCity',
      '#ogPropPincode',
      '#ogPropDate',
      '#ogPropType',
      '#ogPropSlot',
      '#ogPropChargeSummary',
      '#ogPropHiddenType',
      '#ogPropHiddenCharge',
      '#ogPropHiddenSelected',
      'input[name^="properties[📍 Delivery City]"]',
      'input[name^="properties[Delivery Pincode]"]',
      'input[name^="properties[Select Date]"]',
      'input[name^="properties[Pick Delivery Type]"]',
      'input[name^="properties[Time Slot]"]',
      'input[name^="properties[Delivery Charge]"]',
      'input[name^="properties[_og_delivery_"]'
    ];
    var fields = [];
    var seen = [];
    document.querySelectorAll(selectors.join(',')).forEach(function (field) {
      if (!field || seen.indexOf(field) > -1) return;
      if (field.id === 'ogInlineLocationInput') return;
      seen.push(field);
      fields.push(field);
    });
    return fields;
  }
  function saveField(field) {
    if (savedDeliveryFields.some(function (item) { return item.field === field; })) {
      return;
    }
    savedDeliveryFields.push({
      field: field,
      disabled: !!field.disabled,
      required: !!field.required,
      requiredAttr: field.getAttribute('required'),
      ariaRequired: field.getAttribute('aria-required'),
      dataRequired: field.getAttribute('data-required'),
      className: field.className
    });
  }
  function enableUnavailableBypass() {
    if (!isUnavailable()) return;
    bypassActive = true;
    getDeliveryFields().forEach(function (field) {
      saveField(field);
      field.disabled = true;
      field.required = false;
      field.removeAttribute('required');
      field.removeAttribute('aria-required');
      field.removeAttribute('data-required');
      if (field.classList) {
        field.classList.remove(
          'required',
          'is-required',
          'field--required',
          'field-error',
          'field--error',
          'error',
          'invalid',
          'is-invalid'
        );
      }
      try {
        field.setCustomValidity('');
      } catch (e) {}
    });
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.noValidate = true;
    }
    removeRequiredMessage();
  }
  function disableUnavailableBypass() {
    if (!bypassActive) return;
    savedDeliveryFields.forEach(function (item) {
      var field = item.field;
      if (!field || !field.isConnected) return;
      field.disabled = item.disabled;
      field.required = item.required;
      if (item.requiredAttr !== null) {
        field.setAttribute('required', item.requiredAttr);
      } else {
        field.removeAttribute('required');
      }
      if (item.ariaRequired !== null) {
        field.setAttribute('aria-required', item.ariaRequired);
      } else {
        field.removeAttribute('aria-required');
      }
      if (item.dataRequired !== null) {
        field.setAttribute('data-required', item.dataRequired);
      } else {
        field.removeAttribute('data-required');
      }
      field.className = item.className;
    });
    savedDeliveryFields = [];
    bypassActive = false;
  }
  function removeRequiredMessage() {
    var phrases = [
      'please fill this required option',
      'please fill required option',
      'please fill this option'
    ];
    document.querySelectorAll('body *').forEach(function (node) {
      if (!node || node.children.length) return;
      var text = normalize(node.textContent || '');
      if (!text) return;
      if (phrases.some(function (phrase) { return text.indexOf(phrase) > -1; })) {
        var wrapper =
          node.closest('.field-error, .field--error, .error, .errors, [class*="error"]') ||
          node;
        wrapper.style.display = 'none';
        wrapper.setAttribute('data-og-hidden-required-error', 'true');
      }
    });
  }
  function isBuyTrigger(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      'button[type="submit"], input[type="submit"], button[name="add"], ' +
      '.shopify-payment-button__button, [data-buy-now], [data-add-to-cart], ' +
      'a[class*="buy"], div[class*="buy-now"]'
    );
  }
  function prepareNativeFlow(event) {
    if (!isUnavailable()) return;
    var trigger = isBuyTrigger(event.target);
    if (!trigger && event.type !== 'submit') return;
    enableUnavailableBypass();
  }
  function syncBypassState() {
    if (isUnavailable()) {
      enableUnavailableBypass();
    } else {
      disableUnavailableBypass();
    }
  }
  window.__ogUnavailableLocation = isUnavailable;
  window.__ogPrepareUnavailableNativeFlow = enableUnavailableBypass;
  window.__ogSyncUnavailableBypass = syncBypassState;
  window.alert = function (message) {
    var text = normalize(message || '');
    if (
      isUnavailable() &&
      (
        text.indexOf('please fill required option') > -1 ||
        text.indexOf('please fill this required option') > -1 ||
        text.indexOf('please fill this option') > -1 ||
        text.indexOf('please fill required') > -1
      )
    ) {
      enableUnavailableBypass();
      removeRequiredMessage();
      return;
    }
    return nativeAlert.apply(window, arguments);
  };
  window.addEventListener('pointerdown', prepareNativeFlow, true);
  window.addEventListener('mousedown', prepareNativeFlow, true);
  window.addEventListener('touchstart', prepareNativeFlow, true);
  window.addEventListener('click', prepareNativeFlow, true);
  window.addEventListener('submit', prepareNativeFlow, true);
  window.addEventListener('invalid', function (event) {
    if (!isUnavailable()) return;
    var root = document.getElementById('og-delivery-widget');
    if (
      root &&
      (
        root.contains(event.target) ||
        /^ogProp/.test(String(event.target && event.target.id || ''))
      )
    ) {
      event.preventDefault();
      enableUnavailableBypass();
    }
  }, true);
  document.addEventListener('input', function (event) {
    if (event.target && event.target.id === 'ogInlineLocationInput') {
      setTimeout(syncBypassState, 0);
    }
  }, true);
  document.addEventListener('click', function (event) {
    if (
      event.target &&
      event.target.closest &&
      event.target.closest('#ogInlineResetBtn')
    ) {
      setTimeout(syncBypassState, 0);
    }
  }, true);
  var observer = new MutationObserver(function () {
    syncBypassState();
    if (isUnavailable()) removeRequiredMessage();
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
window.initOgGooglePlacesDelivery = function () {
  window.__ogGooglePlacesReady = true;
  if (typeof window.__initOgDeliveryCore === 'function') {
    window.__initOgDeliveryCore();
  }
};
(function () {
  'use strict';
  var SHEET_CACHE_KEY = 'og_delivery_sheet_cache_v11';
  var SHEET_STALE_CACHE_KEY = 'og_delivery_sheet_stale_v11';
  var SELECTION_CACHE_KEY = 'og_delivery_selection_v11';
  var googleAutocompleteService = null;
  var googlePlacesService = null;
  var googleGeocoder = null;
  var googleSessionToken = null;
  function pad(n) {
    return String(n).padStart(2, '0');
  }
  function now() {
    return new Date();
  }
  function todayDate() {
    var d = now();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }
  function ymd(d) {
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  }
  function normalize(v) {
    return String(v || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function keyNorm(v) {
    return String(v || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }
  function escapeHtml(v) {
    return String(v || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function extractPincode(v) {
    var m = String(v || '').match(/\b\d{6}\b/);
    return m ? m[0] : '';
  }
  function toNumber(v) {
    if (v === true) return 1;
    if (v === false || v === null || v === undefined) return 0;
    var raw = String(v).trim();
    var compact = raw.replace(/\s+/g, '').toLowerCase();
    if (/^(yes|y|true|available|serviceable|enabled)$/i.test(raw)) return 1;
    if (/^(no|n|false|na|n\/a|notavailable|disabled)$/i.test(compact)) return 0;
    var n = Number(raw.replace(/[₹,\s]/g, ''));
    return Number.isFinite(n) ? n : 0;
  }
  function money(v, currency) {
    var n = Number(v || 0);
    if (!Number.isFinite(n)) n = 0;
    return (currency || '₹') + String(n);
  }
  function displayPrice(v, currency) {
    var n = Number(v || 0);
    return n === 0 ? 'FREE' : money(n, currency);
  }
  function buildReadableLocation(parts) {
    var out = [];
    (parts || []).forEach(function (item) {
      item = String(item || '').trim();
      if (item && out.indexOf(item) === -1) out.push(item);
    });
    return out.join(', ');
  }
  function buildResolvedLocationLabel(pin, googleLabel, fallbackCity) {
    pin = String(pin || '').trim();
    var label = String(googleLabel || '').trim();
    var city = String(fallbackCity || '').trim();
    label = label
      .replace(/\b\d{6}\b\s*,?\s*/g, '')
      .replace(/^\s*,\s*|\s*,\s*$/g, '')
      .replace(/\s*,\s*/g, ', ')
      .replace(/\s+/g, ' ')
      .trim();
    if (!label) label = city;
    return buildReadableLocation([pin, label]);
  }
  function formatMetaDate(d) {
    return d.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  }
  function formatSelectedDateLabel(d) {
    var t = todayDate();
    var tm = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1);
    if (ymd(d) === ymd(t)) return 'Today, ' + formatMetaDate(d);
    if (ymd(d) === ymd(tm)) return 'Tomorrow, ' + formatMetaDate(d);
    return formatMetaDate(d);
  }
  function getConfig() {
    var node = document.getElementById('og-delivery-config');
    if (!node) {
      console.error('[OG Delivery] Missing #og-delivery-config');
      return null;
    }
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      console.error('[OG Delivery] Invalid config JSON', e);
      return null;
    }
  }
  function fetchJson(url, options) {
    return fetch(url, options || {}).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (txt) {
          throw new Error(txt || ('HTTP ' + res.status));
        });
      }
      return res.json();
    });
  }
  function fetchCart() {
    return fetchJson('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
  }
  function postCartAdd(payload) {
    return fetchJson('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });
  }
  function postCartUpdate(updates) {
    return fetchJson('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    });
  }
  function dispatchCartRefresh() {
    [
      'cart:refresh',
      'cart:build',
      'cart:updated',
      'cart:change',
      'ajaxCart:updated'
    ].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name));
      window.dispatchEvent(new CustomEvent(name));
    });
    setTimeout(markFeeLinesInDom, 200);
    setTimeout(markFeeLinesInDom, 800);
    setTimeout(markFeeLinesInDom, 1600);
    setTimeout(markFeeLinesInDom, 2600);
    if (typeof window.__ogRenderCartDeliveryCharges === 'function') {
      setTimeout(window.__ogRenderCartDeliveryCharges, 250);
      setTimeout(window.__ogRenderCartDeliveryCharges, 900);
      setTimeout(window.__ogRenderCartDeliveryCharges, 1800);
    }
  }
  function openCartUi() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    window.dispatchEvent(new CustomEvent('cart:open'));
    var selectors = [
      '[data-cart-drawer-trigger]',
      '[data-drawer-id="cart"]',
      '.js-drawer-open-cart',
      '.header__icon--cart',
      '.cart-link',
      'a[href="/cart"]',
      'button[name="cart"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var trigger = document.querySelector(selectors[i]);
      if (trigger && typeof trigger.click === 'function') {
        try {
          trigger.click();
          return;
        } catch (e) {}
      }
    }
  }
  function markFeeLinesInDom() {
    var selectors = [
      '[data-cart-item]',
      '.cart-item',
      '.drawer__item',
      '.mini-cart__item',
      '.ajaxcart__product',
      '.cart-drawer__item',
      '.cart__item',
      '[class*="cart-item"]',
      '[class*="CartItem"]'
    ];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (line) {
        var text = normalize(line.textContent || '');
        if (
          text.indexOf('delivery fee') > -1 ||
          text.indexOf('shipping fee') > -1 ||
          text.indexOf('_og_delivery_fee') > -1
        ) {
          line.setAttribute('data-og-delivery-fee-line', 'true');
          line.classList.add('og-hide-delivery-fee-line');
        }
      });
    });
  }
  function initGoogleServices() {
    if (!window.google || !window.google.maps || !window.google.maps.places) return false;
    try {
      googleAutocompleteService = googleAutocompleteService || new google.maps.places.AutocompleteService();
      googleGeocoder = googleGeocoder || new google.maps.Geocoder();
      if (!googlePlacesService) {
        var div = document.createElement('div');
        googlePlacesService = new google.maps.places.PlacesService(div);
      }
      if (!googleSessionToken && google.maps.places.AutocompleteSessionToken) {
        googleSessionToken = new google.maps.places.AutocompleteSessionToken();
      }
      return true;
    } catch (e) {
      return false;
    }
  }
  function initOgDelivery() {
    var root = document.getElementById('og-delivery-widget');
    var config = getConfig();
    if (!root || !config) return;
    if (root.getAttribute('data-og-enabled') !== 'true') return;
    if (root.__ogMounted) {
      if (typeof root.__ogSoftRestore === 'function') root.__ogSoftRestore();
      return;
    }
    root.__ogMounted = true;
    ensureRestoredLockStyles();
    var currency = config.currencySymbol || '₹';
    var sheetUrl = config.sheetUrl || '';
    var sheetCacheTtlMs = Number(config.sheetCacheTtlMs || 10800000);
    var sheetStaleCacheTtlMs = Number(config.sheetStaleCacheTtlMs || 86400000);
    var restoreTtlMs = Number(config.restoreTtlMs || 3600000);
    var deliveryFeeProductId = Number(config.deliveryFeeProductId || 0);
    var feeVariantByAmount = config.feeVariantByAmount || {};
    var productForm =
      root.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
    var els = {
      input: document.getElementById('ogInlineLocationInput'),
      reset: document.getElementById('ogInlineResetBtn'),
      msg: document.getElementById('ogInlineMessage'),
      suggestions: document.getElementById('ogLocationSuggestions'),
      flow: document.getElementById('ogDeliveryFlow'),
      dateOptions: document.getElementById('ogDateOptions'),
      typeOptions: document.getElementById('ogTypeOptions'),
      slotTitle: document.getElementById('ogSlotTitle'),
      slotOptions: document.getElementById('ogSlotOptions'),
      summary: document.getElementById('ogDeliverySummary'),
      selectedLines: document.getElementById('ogSelectedLines'),
      modify: document.getElementById('ogDeliveryModify'),
      calendarPanel: document.getElementById('ogCalendarPanel'),
      calendarOverlay: document.getElementById('ogCalendarOverlay'),
      calendarClose: document.getElementById('ogCalendarClose'),
      calendarPrev: document.getElementById('ogCalendarPrev'),
      calendarNext: document.getElementById('ogCalendarNext'),
      calendarMonthLabel: document.getElementById('ogCalendarMonthLabel'),
      calendarDays: document.getElementById('ogCalendarDays'),
      propCity: document.getElementById('ogPropCity'),
      propPincode: document.getElementById('ogPropPincode'),
      propDate: document.getElementById('ogPropDate'),
      propType: document.getElementById('ogPropType'),
      propSlot: document.getElementById('ogPropSlot'),
      propChargeSummary: document.getElementById('ogPropChargeSummary'),
      propHiddenType: document.getElementById('ogPropHiddenType'),
      propHiddenCharge: document.getElementById('ogPropHiddenCharge'),
      propHiddenSelected: document.getElementById('ogPropHiddenSelected')
    };
    var sheetRows = [];
    var activeSuggestions = [];
    var suggestionTimer = null;
    var googleRequestToken = 0;
    var isSubmitting = false;
    var state = {
      matchedLocation: null,
      selectedDate: '',
      selectedDateLabel: '',
      selectedType: '',
      selectedSlot: null,
      finalCharge: 0,
      finalChargeLabel: '',
      calendarMonth: null
    };
    var isEditingDeliverySelection = false;
    /*
     * True only when a completed selection was restored from storage.
     * It protects the restored summary from delayed Google/autocomplete/
     * theme events that can otherwise reset state after first paint.
     */
    var restoredSelectionLocked = false;
    function isUnavailableLocation() {
      return typeof window.__ogUnavailableLocation === 'function'
        ? window.__ogUnavailableLocation()
        : false;
    }
    function getCurrentProductForm() {
      return (
        root.closest('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]') ||
        productForm
      );
    }

    function ensureDeliveryStateStyles() {
      if (document.getElementById('og-delivery-state-style')) return;
      var style = document.createElement('style');
      style.id = 'og-delivery-state-style';
      style.textContent =
        '#ogDeliveryFlow.is-location-pending > *{' +
          'display:none!important;' +
        '}' +
        '#ogDeliveryFlow.is-location-pending > [data-og-date-section="true"]{' +
          'display:block!important;' +
        '}' +
        '#ogDeliveryFlow.is-location-pending .og-date-card{' +
          'opacity:.58!important;' +
          'cursor:not-allowed!important;' +
          'pointer-events:none!important;' +
          'background:#f7f7f7!important;' +
        '}' +
        '#ogDeliveryFlow.is-location-pending .og-date-card.is-active{' +
          'box-shadow:none!important;' +
        '}' +
        '#ogSelectedLines .og-summary-charge{' +
          'margin-top:3px!important;' +
          'font-size:15px!important;' +
          'line-height:1.4!important;' +
        '}' +
        '#ogSelectedLines .og-summary-charge__label{' +
          'color:#d35400!important;' +
          'font-weight:800!important;' +
        '}' +
        '#ogSelectedLines .og-summary-charge__value{' +
          'color:#087f23!important;' +
          'font-size:16px!important;' +
          'font-weight:900!important;' +
        '}' +
        '@media(max-width:749px){' +
          '#ogSelectedLines .og-summary-charge{font-size:14px!important;}' +
          '#ogSelectedLines .og-summary-charge__value{font-size:15px!important;}' +
        '}';
      document.head.appendChild(style);
    }


    function ensureRestoredLockStyles() {
      if (document.getElementById('og-restored-lock-style')) return;

      var style = document.createElement('style');
      style.id = 'og-restored-lock-style';
      style.textContent =
        '#og-delivery-widget[data-og-restored-lock="true"] .og-delivery__flow > .og-delivery__section{' +
          'display:none!important;' +
        '}' +
        '#og-delivery-widget[data-og-restored-lock="true"] .og-delivery__flow > [data-og-date-section="true"]{' +
          'display:block!important;' +
        '}' +
        '#og-delivery-widget[data-og-restored-lock="true"] #ogDeliverySummary{' +
          'display:flex!important;' +
        '}';

      document.head.appendChild(style);
    }

    function markDateSection() {
      if (!els.flow || !els.dateOptions) return;
      var section = els.dateOptions;
      while (section.parentElement && section.parentElement !== els.flow) {
        section = section.parentElement;
      }
      if (section && section.parentElement === els.flow) {
        section.setAttribute('data-og-date-section', 'true');
      }
    }

    function syncDeliveryFlowVisibility() {
      if (!els.flow) return;
      ensureDeliveryStateStyles();
      markDateSection();
      var unavailable = isUnavailableLocation();
      if (unavailable) {
        els.flow.hidden = true;
        els.flow.classList.remove('is-location-pending');
        return;
      }
      els.flow.hidden = false;
      els.flow.classList.toggle('is-location-pending', !state.matchedLocation);
    }
   function ensureUnavailableNoticeStyle() {
  if (document.getElementById('og-unavailable-notice-style')) return;
  var style = document.createElement('style');
  style.id = 'og-unavailable-notice-style';
  style.textContent =
    '.og-delivery__inline-message.is-unavailable{' +
      'display:block!important;' +
      'margin-top:12px!important;' +
      'padding:0!important;' +
      'background:transparent!important;' +
      'border:0!important;' +
      'color:inherit!important;' +
    '}' +
    '.og-unavailable-notice{' +
      'display:flex;' +
      'align-items:center;' +
      'justify-content:center;' +
      'gap:4px;' +
      'width:max-content;' +
      'max-width:100%;' +
      'margin:0 auto;' +
      'padding:8px 12px;' +
      'border-radius:4px;' +
      'background:#efffe8;' +
      'color:#111;' +
      'font-size:13px;' +
      'font-weight:600;' +
      'line-height:1.35;' +
      'text-align:center;' +
      'box-sizing:border-box;' +
      'flex-wrap:wrap;' +
    '}' +
    '.og-unavailable-notice__link{' +
      'color:#ff7a00!important;' +
      'font-weight:700!important;' +
      'text-decoration:none!important;' +
      'white-space:nowrap;' +
    '}' +
    '.og-unavailable-notice__link:hover{' +
      'text-decoration:underline!important;' +
    '}' +
    '@media(max-width:749px){' +
      '.og-unavailable-notice{' +
        'width:100%;' +
        'font-size:12px;' +
        'padding:8px 10px;' +
      '}' +
    '}';
  document.head.appendChild(style);
}
function setUnavailableMsg(pin) {
  if (!els.msg) return;
  ensureUnavailableNoticeStyle();
  var cleanPin = /^\d{6}$/.test(String(pin || '').trim())
    ? String(pin).trim()
    : '';
  var destinationText = cleanPin
    ? 'See Available Gifts To ' + cleanPin
    : 'See Available Gifts';
  els.msg.innerHTML =
    '<div class="og-unavailable-notice">' +
      '<span>This product cannot be delivered.</span>' +
      '<a href="https://shorturl.at/3aNav" class="og-unavailable-notice__link">' +
        escapeHtml(destinationText) +
      '</a>' +
    '</div>';
  els.msg.className = 'og-delivery__inline-message is-unavailable';
}
function setMsg(text, type) {
  if (!els.msg) return;
  els.msg.textContent = text || '';
  els.msg.className = 'og-delivery__inline-message' + (type ? ' is-' + type : '');
}
    function setValue(node, value) {
      if (node) node.value = value || '';
    }
    function ensurePropertyInput(name) {
      var form = getCurrentProductForm();
      if (!form) return null;
      var fullName = 'properties[' + name + ']';
      var node = form.querySelector('input[name="' + fullName + '"]');
      if (!node) {
        node = document.createElement('input');
        node.type = 'hidden';
        node.name = fullName;
        form.appendChild(node);
      }
      return node;
    }
    function updateFormProperty(name, value) {
      var node = ensurePropertyInput(name);
      if (node) node.value = value || '';
    }
    function pickFromObject(obj, names) {
      var normalized = {};
      Object.keys(obj || {}).forEach(function (key) {
        normalized[keyNorm(key)] = obj[key];
      });
      for (var i = 0; i < names.length; i++) {
        var val = normalized[keyNorm(names[i])];
        if (val !== undefined && val !== null && String(val).trim() !== '') {
          return val;
        }
      }
      return '';
    }
    function transformRows(rows) {
      return (Array.isArray(rows) ? rows : []).map(function (row) {
        var location = String(pickFromObject(row, [
          'DeliveryData',
          'Delivery Data',
          'Location',
          'Service Area',
          'Area',
          'Address',
          'City Pincode'
        ]) || '').trim();
        var cityFromCol = String(pickFromObject(row, [
          'City',
          'Town',
          'Location City'
        ]) || '').trim();
        var pinFromCol = String(pickFromObject(row, [
          'Pincode',
          'Pin Code',
          'PinCode',
          'Postal Code',
          'Zip'
        ]) || '').trim();
        var pin = extractPincode(pinFromCol) || extractPincode(location);
        var city = cityFromCol || location
          .replace(/\s*[-–,]\s*\d{6}\s*.*$/, '')
          .replace(/\b\d{6}\b/g, '')
          .replace(/\s*,\s*$/, '')
          .trim();
        if (!location) location = buildReadableLocation([city, pin]);
        function p(names) {
          return toNumber(pickFromObject(row, names));
        }
        var obj = {
          rawLocation: location,
          city: city,
          pincode: pin,
          displayMeta: location,
          morning: p(['Morning Delivery', 'Morning']),
          morningCharge: p(['Morning Charge', 'Morning Delivery Charge', 'Morning Price']),
          express: p(['Express Delivery', 'Express']),
          expressCharge: p(['Express Charge', 'Express Delivery Charge', 'Express Price']),
          standard: p(['Standard Delivery', 'Standard']),
          standardCharge: p(['Standard Charge', 'Standard Delivery Charge', 'Standard Price']),
          fixedTime: p(['Fixed Time Delivery', 'Fixed Time', 'Fixed']),
          fixedTimeCharge: p(['Fixed Time Charge', 'Fixed Time Delivery Charge', 'Fixed Price']),
          midnight: p(['Midnight Delivery', 'Midnight']),
          midnightCharge: p(['Midnight Charge', 'Midnight Delivery Charge', 'Midnight Price']),
          freeSlot: p(['Free Slot', 'FreeSlot', 'Free']),
          nextDay: p(['Next Day Delivery', 'Next Day', 'NextDay']),
          nextDayCharge: p(['Next Day Charge', 'Next Day Delivery Charge', 'NextDay Charge', 'Next Day Price']),
          remoteDelivery: p(['Remote Delivery', 'Remote']),
          remoteCharge: p(['Remote Charge', 'Remote Area Charge', 'Remote Delivery Charge', 'Remote Price'])
        };
        if (obj.express > 1 && !obj.expressCharge) obj.expressCharge = obj.express;
        if (obj.morning > 1 && !obj.morningCharge) obj.morningCharge = obj.morning;
        if (obj.standard > 1 && !obj.standardCharge) obj.standardCharge = obj.standard;
        if (obj.fixedTime > 1 && !obj.fixedTimeCharge) obj.fixedTimeCharge = obj.fixedTime;
        if (obj.midnight > 1 && !obj.midnightCharge) obj.midnightCharge = obj.midnight;
        if (obj.nextDay > 1 && !obj.nextDayCharge) obj.nextDayCharge = obj.nextDay;
        if (obj.remoteDelivery > 1 && !obj.remoteCharge) obj.remoteCharge = obj.remoteDelivery;
        return obj;
      }).filter(function (row) {
        return row.city || row.pincode;
      });
    }
    function readSheetCache(key, ttl) {
      try {
        var raw = sessionStorage.getItem(key) || localStorage.getItem(key);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (!parsed || !Array.isArray(parsed.rows)) return null;
        if ((Date.now() - Number(parsed.ts || 0)) > ttl) return null;
        return parsed.rows;
      } catch (e) {
        return null;
      }
    }
    function writeSheetCache(rows) {
      var payload = JSON.stringify({
        ts: Date.now(),
        rows: rows
      });
      try { sessionStorage.setItem(SHEET_CACHE_KEY, payload); } catch (e) {}
      try { localStorage.setItem(SHEET_CACHE_KEY, payload); } catch (e) {}
      try { sessionStorage.setItem(SHEET_STALE_CACHE_KEY, payload); } catch (e) {}
      try { localStorage.setItem(SHEET_STALE_CACHE_KEY, payload); } catch (e) {}
    }
     function fetchSheetRows(forceRefresh) {
  if (!sheetUrl) return Promise.resolve([]);

  var requestUrl = sheetUrl;

  if (forceRefresh) {
    requestUrl +=
      (requestUrl.indexOf('?') > -1 ? '&' : '?') +
      '_og_refresh=' +
      Date.now();
  }

  return fetchJson(requestUrl, {
    cache: forceRefresh ? 'reload' : 'default',
    headers: { Accept: 'application/json' }
  }).then(function (json) {
    var rows = Array.isArray(json)
      ? json
      : (
          json &&
          (
            json.rows ||
            json.data ||
            json.values
          )
        ) || [];

    rows = transformRows(rows);
    sheetRows = rows;
    writeSheetCache(rows);

    return rows;
  });
}
    function bootSheetRows() {
  var fresh = readSheetCache(
    SHEET_CACHE_KEY,
    sheetCacheTtlMs
  );

  if (fresh && fresh.length) {
    sheetRows = fresh;
    return Promise.resolve(fresh);
  }

  var stale = readSheetCache(
    SHEET_STALE_CACHE_KEY,
    sheetStaleCacheTtlMs
  );

  if (stale && stale.length) {
    sheetRows = stale;

    fetchSheetRows(true).catch(function (err) {
      console.warn(
        '[OG Delivery] Background JSON refresh failed',
        err
      );
    });

    return Promise.resolve(stale);
  }

  return fetchSheetRows(false).catch(function (err) {
    console.error(
      '[OG Delivery] Sheet fetch failed',
      err
    );

    setMsg(
      'Delivery data loading failed. Please try again.',
      'error'
    );

    return [];
  });
}
    function findByPincode(pin) {
      pin = String(pin || '').trim();
      if (!pin) return null;
      for (var i = 0; i < sheetRows.length; i++) {
        if (String(sheetRows[i].pincode || '').trim() === pin) return sheetRows[i];
      }
      return null;
    }
    function findDefaultRowByCity(city) {
      var input = normalize(city);
      if (!input) return null;
      var exact = sheetRows.filter(function (row) {
        return normalize(row.city) === input && /^\d{6}$/.test(String(row.pincode || '').trim());
      });
      if (!exact.length) {
        exact = sheetRows.filter(function (row) {
          var cityNorm = normalize(row.city);
          var rawNorm = normalize(row.rawLocation);
          return (
            (cityNorm.indexOf(input) > -1 || input.indexOf(cityNorm) > -1 || rawNorm.indexOf(input) > -1) &&
            /^\d{6}$/.test(String(row.pincode || '').trim())
          );
        });
      }
      if (!exact.length) return null;
      exact.sort(function (a, b) {
        return Number(a.pincode || 999999) - Number(b.pincode || 999999);
      });
      return exact[0];
    }
    function findByCity(city) {
      var input = normalize(city);
      if (!input) return null;
      var matches = sheetRows.filter(function (row) {
        var cityNorm = normalize(row.city);
        var rawNorm = normalize(row.rawLocation);
        return (
          cityNorm === input ||
          rawNorm === input ||
          cityNorm.indexOf(input) > -1 ||
          rawNorm.indexOf(input) > -1 ||
          input.indexOf(cityNorm) > -1
        );
      });
      if (!matches.length) return null;
      var first = matches[0];
      function anyFlag(key) {
        return matches.some(function (r) {
          return Number(r[key] || 0) > 0;
        }) ? 1 : 0;
      }
      function maxVal(key) {
        return matches.reduce(function (a, r) {
          return Math.max(a, Number(r[key] || 0));
        }, 0);
      }
      return {
        rawLocation: first.rawLocation,
        city: first.city,
        pincode: '',
        displayMeta: first.displayMeta || first.rawLocation,
        morning: anyFlag('morning'),
        morningCharge: maxVal('morningCharge'),
        express: anyFlag('express'),
        expressCharge: maxVal('expressCharge'),
        standard: anyFlag('standard'),
        standardCharge: maxVal('standardCharge'),
        fixedTime: anyFlag('fixedTime'),
        fixedTimeCharge: maxVal('fixedTimeCharge'),
        midnight: anyFlag('midnight'),
        midnightCharge: maxVal('midnightCharge'),
        freeSlot: anyFlag('freeSlot'),
        nextDay: anyFlag('nextDay'),
        nextDayCharge: maxVal('nextDayCharge'),
        remoteDelivery: anyFlag('remoteDelivery'),
        remoteCharge: maxVal('remoteCharge')
      };
    }
    function hasSameDayType(row) {
      if (!row) return false;
      return !!(
        Number(row.morning || 0) ||
        Number(row.express || 0) ||
        Number(row.standard || 0) ||
        Number(row.fixedTime || 0) ||
        Number(row.midnight || 0) ||
        Number(row.freeSlot || 0)
      );
    }
    function isAfterCutoff() {
      return now().getHours() >= Number(config.cutoffHour || 20);
    }
    function getMinSelectableDate(match) {
      var d = todayDate();
      if (isAfterCutoff() || !hasSameDayType(match)) {
        d.setDate(d.getDate() + 1);
      }
      return d;
    }
    function getMaxSelectableDate() {
      var d = todayDate();
      d.setDate(d.getDate() + Number(config.defaultDateWindowDays || 90));
      return d;
    }
    function isDateDisabled(dateObj) {
      var key = ymd(dateObj);
      var min = getMinSelectableDate(state.matchedLocation);
      var max = getMaxSelectableDate();
      var only = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
      var minOnly = new Date(min.getFullYear(), min.getMonth(), min.getDate());
      var maxOnly = new Date(max.getFullYear(), max.getMonth(), max.getDate());
      if (only < minOnly) return true;
      if (only > maxOnly) return true;
      if (
        config.specialDates &&
        Array.isArray(config.specialDates.disabled) &&
        config.specialDates.disabled.indexOf(key) > -1
      ) {
        return true;
      }
      return false;
    }
    function getLocationLabel() {
      if (!state.matchedLocation) return '';
      return (
        state.matchedLocation.selectedDisplayLabel ||
        buildResolvedLocationLabel(
          state.matchedLocation.pincode,
          state.matchedLocation.displayMeta || state.matchedLocation.rawLocation,
          state.matchedLocation.city
        ) ||
        ''
      );
    }
    function getTypeCfg(typeKey) {
      return config.deliveryTypes && config.deliveryTypes[typeKey]
        ? config.deliveryTypes[typeKey]
        : null;
    }
    function typeCharge(typeKey, row) {
      row = row || state.matchedLocation || {};
      var cfg = getTypeCfg(typeKey);
      var cfgCharge = cfg ? Number(cfg.defaultCharge || 0) : 0;
      if (typeKey === 'standard') return Number(row.standardCharge || cfgCharge || 0);
      if (typeKey === 'express') return Number(row.expressCharge || cfgCharge || 0);
      if (typeKey === 'morning') return Number(row.morningCharge || cfgCharge || 0);
      if (typeKey === 'fixed_time') return Number(row.fixedTimeCharge || cfgCharge || 0);
      if (typeKey === 'midnight') return Number(row.midnightCharge || cfgCharge || 0);
      if (typeKey === 'free_slot') return 0;
      if (typeKey === 'next_day_delivery') return Number(row.nextDayCharge || cfgCharge || 0);
      if (typeKey === 'remote_delivery') return Number(row.remoteCharge || cfgCharge || 0);
      return cfgCharge;
    }
    function allowedTypeKeysFromRow(row, selectedDate) {
      if (!row) return [];
      var out = [];
      var isToday = selectedDate === ymd(todayDate());
      if (Number(row.morning || 0) > 0) out.push('morning');
      if (Number(row.express || 0) > 0) out.push('express');
      if (Number(row.standard || 0) > 0) out.push('standard');
      if (Number(row.fixedTime || 0) > 0) out.push('fixed_time');
      if (Number(row.midnight || 0) > 0) out.push('midnight');
      if (Number(row.freeSlot || 0) > 0) out.push('free_slot');
      if (!isToday && Number(row.nextDay || 0) > 0) out.push('next_day_delivery');
      if (!isToday && (Number(row.remoteDelivery || 0) > 0 || Number(row.remoteCharge || 0) > 0)) {
        out.push('remote_delivery');
      }
      return out.filter(function (v, i, arr) {
        return arr.indexOf(v) === i && !!getTypeCfg(v);
      });
    }
    function getSpecialDateMeta(dateKey) {
      if (!config.specialDates || !config.specialDates.limited) return null;
      return config.specialDates.limited[dateKey] || null;
    }
    function getFilteredSlotsForType(typeKey, selectedDate) {
      var cfg = getTypeCfg(typeKey);
      if (!cfg || !Array.isArray(cfg.slots)) return [];
      var slots = cfg.slots.map(function (slot) {
        return {
          label: slot.label,
          startHour: Number(slot.startHour || 0),
          startMinute: Number(slot.startMinute || 0),
          endHour: Number(slot.endHour || slot.startHour || 0),
          endMinute: Number(slot.endMinute || slot.startMinute || 0),
          extraCharge: Number(slot.extraCharge || 0)
        };
      });
      var meta = getSpecialDateMeta(selectedDate || '');
      if (meta && Array.isArray(meta.allowedSlots) && meta.allowedSlots.length) {
        slots = slots.filter(function (slot) {
          return meta.allowedSlots.indexOf(slot.label) > -1;
        });
      }
      if (selectedDate !== ymd(todayDate())) return slots;
      var currentMinutes = now().getHours() * 60 + now().getMinutes();
      return slots.filter(function (slot) {
        var startMinutes = Number(slot.startHour || 0) * 60 + Number(slot.startMinute || 0);
        return startMinutes > currentMinutes;
      });
    }
    function availableTypesForLocation(match, selectedDate) {
      if (!match || !selectedDate) return [];
      return allowedTypeKeysFromRow(match, selectedDate).map(function (key) {
        var cfg = getTypeCfg(key);
        var slots = getFilteredSlotsForType(key, selectedDate);
        if (!cfg || !slots.length) return null;
        return {
          key: key,
          label: cfg.label,
          charge: typeCharge(key, match)
        };
      }).filter(Boolean);
    }
    function calculateCharges() {
      var cfg = getTypeCfg(state.selectedType);
      var base = cfg ? typeCharge(state.selectedType, state.matchedLocation) : 0;
      var extra = Number((state.selectedSlot && state.selectedSlot.extraCharge) || 0);
      state.finalCharge = Number(base || 0) + Number(extra || 0);
      state.finalChargeLabel = cfg ? cfg.label + ' ' + money(state.finalCharge || 0, currency) : '';
    }
    function isReady() {
      return !!(
        state.matchedLocation &&
        state.selectedDate &&
        state.selectedType &&
        state.selectedSlot
      );
    }
    function applyProperties() {
      calculateCharges();
      var cfg = getTypeCfg(state.selectedType);
      var ready = isReady();
      var city = ready ? String(state.matchedLocation.city || '') : '';
      var pin = ready ? String(state.matchedLocation.pincode || '') : '';
      var date = ready ? String(state.selectedDateLabel || '') : '';
      var type = ready && cfg ? String(cfg.label || '') : '';
      var slot = ready ? String(state.selectedSlot.label || '') : '';
      var charge = ready ? String(state.finalChargeLabel || '') : '';
      setValue(els.propCity, city);
      setValue(els.propPincode, pin);
      setValue(els.propDate, date);
      setValue(els.propType, type);
      setValue(els.propSlot, slot);
      setValue(els.propChargeSummary, charge);
      setValue(els.propHiddenType, state.selectedType || '');
      setValue(els.propHiddenCharge, ready ? String(state.finalCharge || 0) : '');
      setValue(els.propHiddenSelected, ready ? '1' : '');
      updateFormProperty('📍 Delivery City', city);
      updateFormProperty('Delivery Pincode', pin);
      updateFormProperty('Select Date', date);
      updateFormProperty('Pick Delivery Type', type);
      updateFormProperty('Time Slot', slot);
      updateFormProperty('Delivery Charge', charge);
      updateFormProperty('_og_delivery_type', state.selectedType || '');
      updateFormProperty('_og_delivery_total_charge', ready ? String(state.finalCharge || 0) : '');
      updateFormProperty('_og_delivery_selected', ready ? '1' : '');
    }
    function getProductFormPayload() {
      applyProperties();
      calculateCharges();
      var form = getCurrentProductForm();
      if (!form) {
        console.error('[OG Delivery] Product form not found');
        return null;
      }
      var formData = new FormData(form);
      var id = Number(formData.get('id'));
      var quantity = Number(formData.get('quantity') || 1);
      if (!id) {
        var variantInput =
          form.querySelector('[name="id"]') ||
          document.querySelector('form[action*="/cart/add"] [name="id"]');
        id = variantInput ? Number(variantInput.value) : 0;
      }
      if (!id) {
        console.error('[OG Delivery] Variant id missing');
        return null;
      }
      var cfg = getTypeCfg(state.selectedType);
      var properties = {
        '📍 Delivery City': state.matchedLocation ? String(state.matchedLocation.city || '') : '',
        'Delivery Pincode': state.matchedLocation ? String(state.matchedLocation.pincode || '') : '',
        'Select Date': state.selectedDateLabel || '',
        'Pick Delivery Type': cfg ? cfg.label : '',
        'Time Slot': state.selectedSlot ? state.selectedSlot.label : '',
        'Delivery Charge': state.finalChargeLabel || '',
        '_og_delivery_type': state.selectedType || '',
        '_og_delivery_total_charge': String(state.finalCharge || 0),
        '_og_delivery_selected': '1'
      };
      Object.keys(properties).forEach(function (key) {
        if (properties[key] === '') delete properties[key];
      });
      return {
        id: id,
        quantity: quantity > 0 ? quantity : 1,
        properties: properties
      };
    }
    function getFeeVariantIdForAmount(amount) {
      amount = Number(amount || 0);
      if (amount <= 0) return null;
      var key = String(amount);
      if (Object.prototype.hasOwnProperty.call(feeVariantByAmount, key)) {
        return Number(feeVariantByAmount[key]);
      }
      console.warn('[OG Delivery] Missing fee variant for amount:', key);
      return null;
    }
    function getItemDeliveryCharge(item) {
      var props = (item && item.properties) || {};
      var amount = Number(props._og_delivery_total_charge || 0);
      if (!Number.isFinite(amount) || amount < 0) amount = 0;
      var label = String(props['Delivery Charge'] || props['Delivery Fee'] || '').trim();
      if (!amount && label) {
        var match = label.match(/₹\s*([0-9,]+)/);
        if (match) amount = Number(String(match[1]).replace(/,/g, '')) || 0;
      }
      return { amount: amount, label: label };
    }
    function getCartSingleDeliveryCharge(cart) {
      var best = { amount: 0, label: '' };
      (cart.items || []).forEach(function (item) {
        var props = item.properties || {};
        var isFee =
          Number(item.product_id || 0) === deliveryFeeProductId ||
          String(props._og_delivery_fee || '') === '1';
        if (isFee) return;
        var charge = getItemDeliveryCharge(item);
        if (charge.amount > best.amount) {
          best = charge;
        } else if (!best.label && charge.label) {
          best.label = charge.label;
        }
      });
      return best;
    }
    function getFeeItemProperties(amount, label) {
      return {
        '_og_delivery_fee': '1',
        '_og_delivery_total_charge': String(Number(amount || 0)),
        'Delivery Fee': label || ('Delivery Charge ' + money(amount, currency))
      };
    }
    function syncFeeItemInCart() {
      if (!deliveryFeeProductId) return Promise.resolve();
      var selectedCharge = { amount: 0, label: '' };
      var feeVariantId = null;
      return fetchCart()
        .then(function (cart) {
          selectedCharge = getCartSingleDeliveryCharge(cart);
          feeVariantId = getFeeVariantIdForAmount(selectedCharge.amount);
          var updates = {};
          var keptCorrectFee = false;
          (cart.items || []).forEach(function (item) {
            var props = item.properties || {};
            var isFee =
              Number(item.product_id || 0) === deliveryFeeProductId ||
              String(props._og_delivery_fee || '') === '1';
            if (!isFee) return;
            var isCorrect = feeVariantId && Number(item.variant_id) === Number(feeVariantId);
            if (isCorrect && !keptCorrectFee) {
              keptCorrectFee = true;
              if (Number(item.quantity || 0) !== 1) updates[item.key] = 1;
            } else {
              updates[item.key] = 0;
            }
          });
          if (Object.keys(updates).length) {
            return postCartUpdate(updates).then(function () {
              return { keptCorrectFee: keptCorrectFee };
            });
          }
          return { keptCorrectFee: keptCorrectFee };
        })
        .then(function (result) {
          if (!feeVariantId || result.keptCorrectFee) return null;
          return postCartAdd({
            id: feeVariantId,
            quantity: 1,
            properties: getFeeItemProperties(selectedCharge.amount, selectedCharge.label)
          });
        })
        .then(function () {
          dispatchCartRefresh();
          setTimeout(renderCartDeliveryCharges, 250);
          setTimeout(renderCartDeliveryCharges, 900);
        })
        .catch(function (err) {
          console.error('[OG Delivery] Fee sync failed', err);
        });
    }
    function ensureCartChargeStyle() {
      if (document.getElementById('og-cart-charge-style')) return;
      var style = document.createElement('style');
      style.id = 'og-cart-charge-style';
      style.textContent =
        '.og-cart-charge-row{' +
          'display:flex!important;' +
          'align-items:center!important;' +
          'gap:4px!important;' +
          'width:100%!important;' +
          'margin:3px 0 5px!important;' +
          'padding:0!important;' +
          'font-size:12px!important;' +
          'line-height:1.35!important;' +
          'visibility:visible!important;' +
          'opacity:1!important;' +
        '}' +
        '.og-cart-charge-row__label{' +
          'color:#a63b00!important;' +
          'font-weight:800!important;' +
        '}' +
        '.og-cart-charge-row__value{' +
          'color:#087a2f!important;' +
          'font-size:13px!important;' +
          'font-weight:900!important;' +
        '}' +
        '[data-og-delivery-fee-line="true"]{display:none!important;}';
      document.head.appendChild(style);
    }

    function isDeliveryFeeCartItem(item) {
      var props = (item && item.properties) || {};
      return !!(
        Number(item && item.product_id || 0) === deliveryFeeProductId ||
        String(props._og_delivery_fee || '') === '1' ||
        normalize(item && item.product_title || '').indexOf('delivery fee') > -1 ||
        normalize(item && item.title || '').indexOf('delivery fee') > -1
      );
    }

    function hasDeliveryDetails(item) {
      var props = (item && item.properties) || {};
      return !!(
        props['📍 Delivery City'] ||
        props['Delivery City'] ||
        props['Delivery Pincode'] ||
        props['Select Date'] ||
        props['Pick Delivery Type'] ||
        props['Time Slot'] ||
        props['Delivery Charge'] ||
        props['_og_delivery_total_charge'] ||
        props['_og_delivery_selected']
      );
    }

    function getFallbackFeeCharge(cart) {
      var result = { amount: 0, label: '' };
      (cart.items || []).forEach(function (item) {
        if (!isDeliveryFeeCartItem(item)) return;
        var props = item.properties || {};
        var amount = Number(props._og_delivery_total_charge || 0);
        if (!amount) amount = Number(item.final_line_price || item.line_price || item.final_price || item.price || 0) / 100;
        if (amount > result.amount) result.amount = amount;
        if (!result.label) result.label = String(props['Delivery Fee'] || '').trim();
      });
      return result;
    }

    function getDeliveryItemsForCart(cart) {
      return (cart.items || []).filter(function (item) {
        return !isDeliveryFeeCartItem(item) && hasDeliveryDetails(item);
      });
    }

    function getCartDrawerRoot() {
      return (
        document.querySelector('[id^="CartDrawerBody-"]') ||
        document.getElementById('CartDrawer') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('.cart-drawer') ||
        document.querySelector('[class*="cart-drawer"]') ||
        document.querySelector('[class*="drawer"][class*="cart"]')
      );
    }

    function escapeCssValue(value) {
      value = String(value || '');
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value);
      }
      return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    function findCartItemNode(root, item) {
      if (!root || !item) return null;
      var variantId = String(item.variant_id || '').trim();
      var key = String(item.key || '').trim();
      var handle = String(item.handle || '').trim();
      var node = null;

      if (variantId) {
        node = root.querySelector(
          'li.cart-item[data-variant-id="' + escapeCssValue(variantId) + '"], ' +
          '[id^="CartDrawer-Item-"][data-variant-id="' + escapeCssValue(variantId) + '"]'
        );
      }
      if (!node && key) {
        node = root.querySelector('[data-key="' + escapeCssValue(key) + '"]');
      }
      if (!node && handle) {
        node = root.querySelector(
          'li.cart-item[data-handle="' + escapeCssValue(handle) + '"], ' +
          '[id^="CartDrawer-Item-"][data-handle="' + escapeCssValue(handle) + '"]'
        );
      }
      return node;
    }

    function findTitleInsertionPoint(cartItem) {
      if (!cartItem) return null;

      var exactTitleBlock = cartItem.querySelector(
        '.cart-item__details .grid.flex-1 > .block'
      );
      if (exactTitleBlock) return exactTitleBlock;

      var details =
        cartItem.querySelector('.cart-item__details') ||
        cartItem.querySelector('[class*="cart-item__details"]');
      if (!details) return null;

      var options = details.querySelector('.cart-item__options');
      if (options && options.previousElementSibling) {
        return options.previousElementSibling;
      }

      var title = details.querySelector(
        '.cart-item__title, [class*="product-title"], [class*="item-title"], a[href*="/products/"], h2, h3, h4'
      );
      return title || details.firstElementChild || details;
    }

    var cartChargeTimer = null;
    var cartChargeRendering = false;

    function renderCartDeliveryCharges() {
      if (cartChargeRendering) return;
      cartChargeRendering = true;
      ensureCartChargeStyle();

      fetchCart().then(function (cart) {
        var root = getCartDrawerRoot();
        if (!root) return;

        root.querySelectorAll('.og-cart-charge-row').forEach(function (node) {
          node.remove();
        });

        var fallback = getFallbackFeeCharge(cart);
        var deliveryItems = getDeliveryItemsForCart(cart);

        deliveryItems.forEach(function (item) {
          var cartItem = findCartItemNode(root, item);
          if (!cartItem) return;

          var anchor = findTitleInsertionPoint(cartItem);
          if (!anchor || !anchor.parentNode) return;

          var charge = getItemDeliveryCharge(item);
          var amount = Number(charge.amount || 0);
          var label = String(charge.label || '').trim();

          if (!amount && fallback.amount) amount = Number(fallback.amount || 0);
          if (!label && fallback.label) label = String(fallback.label || '').trim();

          var value = amount > 0 ? money(amount, currency) : '';
          if (!value && label) {
            var match = label.match(/₹\s*([0-9,]+)/);
            value = match ? ('₹' + String(match[1]).replace(/,/g, '')) : label;
          }
          if (!value) return;

          var row = document.createElement('div');
          row.className = 'og-cart-charge-row';
          row.setAttribute('data-og-variant-id', String(item.variant_id || ''));
          row.innerHTML =
            '<span class="og-cart-charge-row__label">Delivery Charge:</span>' +
            '<span class="og-cart-charge-row__value">' + escapeHtml(value) + '</span>';

          anchor.parentNode.insertBefore(row, anchor.nextSibling);
        });
      }).catch(function (err) {
        console.error('[OG Delivery] Cart charge display failed', err);
      }).then(function () {
        cartChargeRendering = false;
      });
    }

    function scheduleCartChargeRender(delay) {
      clearTimeout(cartChargeTimer);
      cartChargeTimer = setTimeout(renderCartDeliveryCharges, Number(delay || 200));
    }

    window.__ogRenderCartDeliveryCharges = renderCartDeliveryCharges;

    ['cart:open', 'cart:refresh', 'cart:updated', 'cart:change', 'ajaxCart:updated'].forEach(function (name) {
      document.addEventListener(name, function () { scheduleCartChargeRender(120); });
      window.addEventListener(name, function () { scheduleCartChargeRender(120); });
    });

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest(
        '.header__icon--cart, [data-cart-drawer-trigger], a[href="/cart"], button[name="cart"], [class*="quantity"], [class*="remove"]'
      )) {
        scheduleCartChargeRender(100);
        setTimeout(renderCartDeliveryCharges, 400);
        setTimeout(renderCartDeliveryCharges, 900);
        setTimeout(renderCartDeliveryCharges, 1800);
      }
    });

    var cartChargeObserver = new MutationObserver(function (mutations) {
      var shouldRender = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node && node.nodeType === 1 && !(node.matches && node.matches('.og-cart-charge-row'));
        });
      });
      if (shouldRender) scheduleCartChargeRender(80);
    });

    cartChargeObserver.observe(document.body, { childList: true, subtree: true });
    scheduleCartChargeRender(300);
    setTimeout(renderCartDeliveryCharges, 800);
    setTimeout(renderCartDeliveryCharges, 1600);

    function clearSelectionCache() {
      try { sessionStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
      try { localStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
    }

    function getSelectionExpiry(selectedDate, selectedSlot) {
      if (!selectedDate || !selectedSlot) return 0;

      var parts = String(selectedDate).split('-');
      if (parts.length !== 3) return 0;

      var year = Number(parts[0]);
      var month = Number(parts[1]) - 1;
      var day = Number(parts[2]);

      if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
        return 0;
      }

      var endHour = Number(selectedSlot.endHour);
      var endMinute = Number(selectedSlot.endMinute);

      if (!Number.isFinite(endHour)) endHour = 23;
      if (!Number.isFinite(endMinute)) endMinute = 59;

      var expiry = new Date(year, month, day, endHour, endMinute, 59, 999);

      /*
       * The saved selection remains valid until the selected delivery
       * slot itself finishes. This keeps the same delivery selection
       * across product pages and browser refreshes without a fixed
       * one-hour timeout.
       */
      return expiry.getTime();
    }

    function isSavedSelectionValid(parsed) {
      if (
        !parsed ||
        !parsed.matchedLocation ||
        !parsed.selectedDate ||
        !parsed.selectedType ||
        !parsed.selectedSlot
      ) {
        return false;
      }

      var expiry = Number(parsed.expiresAt || 0);

      /* Backward compatibility for older cached selections. */
      if (!expiry) {
        expiry = getSelectionExpiry(parsed.selectedDate, parsed.selectedSlot);
      }

      if (!expiry || Date.now() >= expiry) {
        return false;
      }

      return true;
    }

    function saveSelection() {
      if (!isReady()) return;

      calculateCharges();

      var expiresAt = getSelectionExpiry(
        state.selectedDate,
        state.selectedSlot
      );

      if (!expiresAt || Date.now() >= expiresAt) {
        clearSelectionCache();
        return;
      }

      var payload = JSON.stringify({
        ts: Date.now(),
        expiresAt: expiresAt,
        matchedLocation: state.matchedLocation,
        selectedDate: state.selectedDate,
        selectedDateLabel: state.selectedDateLabel,
        selectedType: state.selectedType,
        selectedSlot: state.selectedSlot,
        finalCharge: state.finalCharge
      });

      try { sessionStorage.setItem(SELECTION_CACHE_KEY, payload); } catch (e) {}
      try { localStorage.setItem(SELECTION_CACHE_KEY, payload); } catch (e) {}
    }

    function readSelectionCache() {
      try {
        var sessionRaw = sessionStorage.getItem(SELECTION_CACHE_KEY);
        var localRaw = localStorage.getItem(SELECTION_CACHE_KEY);
        var sessionParsed = sessionRaw ? JSON.parse(sessionRaw) : null;
        var localParsed = localRaw ? JSON.parse(localRaw) : null;

        /*
         * Prefer the newest valid copy. localStorage makes the selection
         * available on every product page in the same browser.
         */
        var candidates = [sessionParsed, localParsed]
          .filter(Boolean)
          .sort(function (a, b) {
            return Number(b.ts || 0) - Number(a.ts || 0);
          });

        return candidates.length ? candidates[0] : null;
      } catch (e) {
        return null;
      }
    }

    function restoreSelection() {
      var parsed = readSelectionCache();

      /*
       * A completed delivery selection is GLOBAL for all Express-tag
       * product pages in this browser. Do not force the customer to
       * select date/type/slot again on every product page.
       *
       * It remains valid until the selected delivery slot ends.
       */
      if (!isSavedSelectionValid(parsed)) {
        clearSelectionCache();
        return false;
      }

      state.matchedLocation = parsed.matchedLocation;
      state.selectedDate = parsed.selectedDate || '';
      state.selectedDateLabel = parsed.selectedDateLabel || '';
      state.selectedType = parsed.selectedType || '';
      state.selectedSlot = parsed.selectedSlot || null;
      state.finalCharge = Number(parsed.finalCharge || 0);

      /*
       * IMPORTANT:
       * Do not re-check the saved choice against the newly opened
       * product's freshly rendered delivery list here. The customer's
       * completed selection is intentionally carried across Express
       * product pages until its date/time expires.
       *
       * Revalidation here was causing a valid saved selection to be
       * cleared and the next product page to show "Choose delivery
       * option" again.
       */

      if (els.input) {
        els.input.value = getLocationLabel();
      }

      isEditingDeliverySelection = false;
      restoredSelectionLocked = true;
      root.setAttribute('data-og-restored-lock', 'true');

      renderAll();
      applyProperties();
      toggleReset();

      if (state.matchedLocation) {
        setMsg('Location found! We deliver to this area.', 'success');
      }

      return true;
    }

    function resetAll() {
      restoredSelectionLocked = false;
      root.removeAttribute('data-og-restored-lock');
      state.matchedLocation = null;
      state.selectedDate = '';
      state.selectedDateLabel = '';
      state.selectedType = '';
      state.selectedSlot = null;
      state.finalCharge = 0;
      state.finalChargeLabel = '';
      if (els.input) els.input.value = '';
      if (els.summary) els.summary.hidden = true;
      if (els.suggestions) els.suggestions.hidden = true;
      setMsg('', '');
      syncDeliveryFlowVisibility();
      renderDateOptions();
      applyProperties();
      toggleReset();
      try { sessionStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
      try { localStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
      syncFeeItemInCart();
    }
    function toggleReset() {
      if (!els.reset) return;
      els.reset.hidden = !((els.input && els.input.value.trim()) || state.matchedLocation);
    }
    function selectDateValue(dateValue) {
      if (dateValue === 'calendar') {
        openCalendar();
        return;
      }
      var parts = dateValue.split('-');
      var dateObj = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      if (isDateDisabled(dateObj)) return;
      state.selectedDate = dateValue;
      state.selectedDateLabel = formatSelectedDateLabel(dateObj);
      state.selectedType = '';
      state.selectedSlot = null;
      var options = availableTypesForLocation(state.matchedLocation, state.selectedDate);
      if (options.length === 1) {
        state.selectedType = options[0].key;
      }
      renderAll();
      closeCalendar();
      setTimeout(function () {
        if (els.typeOptions) {
          els.typeOptions.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }, 120);
    }
    function renderDateOptions() {
      if (!els.dateOptions) return;
      var locationPending = !state.matchedLocation;
      var t = todayDate();
      var tm = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1);
      var items = [
        {
          value: ymd(t),
          title: 'Today',
          meta: formatMetaDate(t),
          disabled: locationPending || isDateDisabled(t)
        },
        {
          value: ymd(tm),
          title: 'Tomorrow',
          meta: formatMetaDate(tm),
          disabled: locationPending || isDateDisabled(tm)
        },
        {
          value: 'calendar',
          title: 'Later',
          meta: 'Pick A Date',
          disabled: locationPending
        }
      ];
      els.dateOptions.innerHTML = items.map(function (item) {
        var active = item.value !== 'calendar' && state.selectedDate === item.value ? ' is-active' : '';
        var disabled = item.disabled ? ' is-disabled' : '';
        return (
          '<button type="button" class="og-date-card' + active + disabled + '" data-og-date="' + escapeHtml(item.value) + '"' +
          (item.disabled ? ' disabled aria-disabled="true"' : '') + '>' +
            '<span class="og-date-card__title">' + escapeHtml(item.title) + '</span>' +
            '<span class="og-date-card__meta">' + escapeHtml(item.meta) + '</span>' +
          '</button>'
        );
      }).join('');
    }
    function getDeliveryTypeIcon(typeKey) {
      var icons = {
        morning:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 18h16M6.3 14.5a5.8 5.8 0 0 1 11.4 0M12 3v3M4.2 7.2l2.1 2.1M19.8 7.2l-2.1 2.1M2 14.5h2.5M19.5 14.5H22"/></svg>',
        standard:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg>',
        express:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m13.5 2-8 11h6l-1 9 8-12h-6z"/></svg>',
        fixed_time:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
        midnight:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 15.5A8 8 0 0 1 8.5 5a8.2 8.2 0 1 0 10.5 10.5Z"/><path d="M17.5 4.5v3M16 6h3M20.5 9v2M19.5 10h2"/></svg>',
        remote_delivery:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z"/><circle cx="12" cy="10" r="2"/></svg>',
        free_slot:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg>',
        next_day_delivery:
          '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18M9 15h6"/></svg>'
      };
      return icons[typeKey] || icons.standard;
    }

    function getDeliveryTypeSubtitle(typeKey, slots) {
      slots = Array.isArray(slots) ? slots : [];
      if (slots.length === 1) return slots[0].label || '';
      if (typeKey === 'express') return 'Select an express time slot';
      if (typeKey === 'fixed_time') return 'Select a fixed delivery time';
      if (typeKey === 'standard') return 'Select a convenient time slot';
      if (typeKey === 'remote_delivery') return 'Select an available delivery slot';
      if (typeKey === 'next_day_delivery') return 'Select an available delivery slot';
      return 'Select a convenient time slot';
    }

    function renderInlineSlotButtons(typeKey, slots) {
      if (!Array.isArray(slots) || slots.length <= 1) return '';
      return (
        '<div class="og-type-card__slots">' +
          '<div class="og-delivery__slot-grid">' +
            slots.map(function (slot, index) {
              var active =
                state.selectedType === typeKey &&
                state.selectedSlot &&
                state.selectedSlot.label === slot.label
                  ? ' is-active'
                  : '';
              return (
                '<button type="button" class="og-slot-card' + active + '"' +
                  ' data-og-inline-slot-index="' + index + '"' +
                  ' data-og-inline-slot-type="' + escapeHtml(typeKey) + '"' +
                  ' aria-pressed="' + (active ? 'true' : 'false') + '">' +
                  '<span class="og-slot-card__label">' + escapeHtml(slot.label) + '</span>' +
                  '<span class="og-slot-card__check" aria-hidden="true">✓</span>' +
                '</button>'
              );
            }).join('') +
          '</div>' +
        '</div>'
      );
    }

    function renderTypeOptions() {
      if (!els.typeOptions) return;
      if (!state.selectedDate) {
        els.typeOptions.innerHTML = '<div class="og-delivery__empty">Select delivery date first.</div>';
        return;
      }

      var options = availableTypesForLocation(state.matchedLocation, state.selectedDate);

      var preferredTypeOrder = [
        'morning',
        'standard',
        'express',
        'fixed_time',
        'midnight'
      ];
      options.sort(function (a, b) {
        var ai = preferredTypeOrder.indexOf(a.key);
        var bi = preferredTypeOrder.indexOf(b.key);
        if (ai === -1) ai = 999;
        if (bi === -1) bi = 999;
        return ai - bi;
      });

      if (!options.length) {
        els.typeOptions.innerHTML = '<div class="og-delivery__empty">No delivery type available for this date.</div>';
        return;
      }

      els.typeOptions.innerHTML = options.map(function (item) {
        var slots = getFilteredSlotsForType(item.key, state.selectedDate);
        var hasMultipleSlots = slots.length > 1;
        var isSelectedType = state.selectedType === item.key;
        var active = isSelectedType ? ' is-active' : '';
        var expanded = hasMultipleSlots && isSelectedType;
        var price = displayPrice(item.charge, currency);
        var priceClass = Number(item.charge || 0) === 0 ? ' is-free' : '';
        var subtitle = getDeliveryTypeSubtitle(item.key, slots);

        return (
          '<div class="og-type-card-wrap' + active + '" data-og-type-wrap="' + escapeHtml(item.key) + '">' +
            '<button type="button" class="og-type-card' + active + '"' +
              ' data-og-type="' + escapeHtml(item.key) + '"' +
              (hasMultipleSlots
                ? ' aria-expanded="' + (expanded ? 'true' : 'false') + '"'
                : ' aria-pressed="' + (isSelectedType && state.selectedSlot ? 'true' : 'false') + '"') +
            '>' +
              '<span class="og-type-card__icon" aria-hidden="true">' +
                getDeliveryTypeIcon(item.key) +
              '</span>' +

              '<span class="og-type-card__body">' +
                '<span class="og-type-card__title">' + escapeHtml(item.label) + '</span>' +
                '<span class="og-type-card__subtitle">' + escapeHtml(subtitle) + '</span>' +
              '</span>' +

              '<span class="og-type-card__right">' +
                '<span class="og-type-card__price' + priceClass + '">' + escapeHtml(price) + '</span>' +
                (hasMultipleSlots
                  ? '<span class="og-type-card__chevron' + (expanded ? ' is-open' : '') + '" aria-hidden="true"></span>'
                  : '') +
              '</span>' +
            '</button>' +

            (expanded ? renderInlineSlotButtons(item.key, slots) : '') +
          '</div>'
        );
      }).join('');
    }

    function renderSlotOptions() {
      if (!els.slotOptions || !els.slotTitle) return;

      var cfg = getTypeCfg(state.selectedType);
      if (!state.selectedType || !cfg) {
        els.slotTitle.textContent = '';
        els.slotOptions.innerHTML = '';
        return;
      }

      var slots = getFilteredSlotsForType(state.selectedType, state.selectedDate);
      els.slotTitle.textContent = slots.length > 1 ? 'Select Time Slot for ' + cfg.label : '';

      if (slots.length <= 1) {
        els.slotOptions.innerHTML = '';
        return;
      }

      els.slotOptions.innerHTML = slots.map(function (slot, index) {
        var active = state.selectedSlot && state.selectedSlot.label === slot.label ? ' is-active' : '';
        return (
          '<button type="button" class="og-slot-card' + active + '" data-og-slot-index="' + index + '">' +
            '<span class="og-slot-card__label">' + escapeHtml(slot.label) + '</span>' +
            '<span class="og-slot-card__check" aria-hidden="true">✓</span>' +
          '</button>'
        );
      }).join('');
    }
    function renderSummary() {
      if (!els.summary || !els.selectedLines) return;
      calculateCharges();
      var cfg = getTypeCfg(state.selectedType);
      var ready = isReady();
      if (!ready || !cfg) {
        els.summary.hidden = true;
        return;
      }
      var lines = [
        ['Delivery City', state.matchedLocation.city || '-'],
        ['Delivery Pincode', state.matchedLocation.pincode || '-'],
        ['Delivery Date', state.selectedDateLabel],
        ['Delivery Type', cfg.label],
        ['Delivery Slot', state.selectedSlot.label],
        ['Delivery Charge', state.finalChargeLabel]
      ];
      els.selectedLines.innerHTML = lines.map(function (pair) {
        if (pair[0] === 'Delivery Charge') {
          return '<div class="og-summary-charge">' +
            '<span class="og-summary-charge__label">Delivery Charge:</span> ' +
            '<span class="og-summary-charge__value">' + escapeHtml(pair[1]) + '</span>' +
          '</div>';
        }
        return '<div><b>' + escapeHtml(pair[0]) + ':</b> ' + escapeHtml(pair[1]) + '</div>';
      }).join('');
      els.summary.hidden = false;
    }
    function renderAll() {
      /*
       * Last-line protection against ALL late async/theme events.
       * While the restored lock exists, rehydrate from storage BEFORE
       * anything can render the fresh chooser.
       */
      if (
        restoredSelectionLocked &&
        !isEditingDeliverySelection
      ) {
        var lockedParsed = readSelectionCache();

        if (isSavedSelectionValid(lockedParsed)) {
          state.matchedLocation = lockedParsed.matchedLocation;
          state.selectedDate = lockedParsed.selectedDate || '';
          state.selectedDateLabel = lockedParsed.selectedDateLabel || '';
          state.selectedType = lockedParsed.selectedType || '';
          state.selectedSlot = lockedParsed.selectedSlot || null;
          state.finalCharge = Number(lockedParsed.finalCharge || 0);

          if (els.input) {
            els.input.value = getLocationLabel();
          }

          root.setAttribute('data-og-restored-lock', 'true');
        } else {
          restoredSelectionLocked = false;
          root.removeAttribute('data-og-restored-lock');
          clearSelectionCache();
        }
      }

      syncDeliveryFlowVisibility();
      renderDateOptions();
      renderTypeOptions();
      renderSlotOptions();
      renderSummary();
      applyProperties();
      toggleReset();

      var summaryMode =
        (isReady() && !isEditingDeliverySelection) ||
        (
          restoredSelectionLocked &&
          root.getAttribute('data-og-restored-lock') === 'true'
        );

      root.classList.toggle('is-summary-mode', summaryMode);

      if (els.summary) {
        els.summary.hidden = !summaryMode;
      }

      if (typeof window.__ogSyncUnavailableBypass === 'function') {
        setTimeout(window.__ogSyncUnavailableBypass, 0);
      }
    }
    function renderCalendar() {
      if (!els.calendarDays || !els.calendarMonthLabel) return;
      var base = state.calendarMonth || new Date(todayDate().getFullYear(), todayDate().getMonth(), 1);
      var year = base.getFullYear();
      var month = base.getMonth();
      var firstDay = new Date(year, month, 1);
      var lastDay = new Date(year, month + 1, 0);
      var todayKey = ymd(todayDate());
      var selectedKey = state.selectedDate || '';
      els.calendarMonthLabel.textContent = base.toLocaleDateString('en-IN', {
        month: 'long',
        year: 'numeric'
      });
      var minDate = getMinSelectableDate(state.matchedLocation);
      var minMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
      var thisMonth = new Date(year, month, 1);
      if (els.calendarPrev) {
        els.calendarPrev.disabled = thisMonth <= minMonth;
      }
      var html = '';
      for (var i = 0; i < firstDay.getDay(); i++) {
        html += '<button type="button" class="og-calendar__day is-empty" tabindex="-1" aria-hidden="true"></button>';
      }
      for (var day = 1; day <= lastDay.getDate(); day++) {
        var dateObj = new Date(year, month, day);
        var dateKey = ymd(dateObj);
        var disabled = isDateDisabled(dateObj);
        var cls = 'og-calendar__day';
        if (disabled) cls += ' is-disabled';
        if (dateKey === todayKey) cls += ' is-today';
        if (dateKey === selectedKey) cls += ' is-selected';
        html += '<button type="button" class="' + cls + '" data-og-calendar-date="' + dateKey + '"' +
          (disabled ? ' disabled aria-disabled="true"' : '') + '>' + day + '</button>';
      }
      var totalCells = firstDay.getDay() + lastDay.getDate();
      var remaining = totalCells % 7 === 0 ? 0 : 7 - (totalCells % 7);
      for (var j = 0; j < remaining; j++) {
        html += '<button type="button" class="og-calendar__day is-empty" tabindex="-1" aria-hidden="true"></button>';
      }
      els.calendarDays.innerHTML = html;
    }
    function openCalendar() {
      var selectedDate = state.selectedDate
        ? new Date(state.selectedDate + 'T00:00:00')
        : getMinSelectableDate(state.matchedLocation);
      state.calendarMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
      renderCalendar();
      if (els.calendarPanel) {
        els.calendarPanel.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }
    }
    function closeCalendar() {
      if (els.calendarPanel) els.calendarPanel.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
    function getSheetSuggestions(input) {
      var q = normalize(input);
      if (!q || q.length < 2) return [];
      var out = [];
      var seen = {};
      sheetRows.forEach(function (row) {
        var city = String(row.city || '').trim();
        var pin = String(row.pincode || '').trim();
        var raw = String(row.rawLocation || '').trim();
        var combined = normalize([city, pin, raw].join(' '));
        if (combined.indexOf(q) === -1) return;
        var key = normalize(city + '|' + pin);
        if (seen[key]) return;
        seen[key] = true;
        out.push({
          source: 'sheet',
          title: buildReadableLocation([city, pin]) || raw,
          meta: raw,
          city: city,
          pincode: pin,
          raw: raw
        });
      });
      return out.slice(0, 10);
    }
    function renderSuggestions(items) {
      if (!els.suggestions) return;
      if (!items || !items.length) {
        els.suggestions.innerHTML = '';
        els.suggestions.hidden = true;
        activeSuggestions = [];
        return;
      }
      activeSuggestions = items.slice();
      els.suggestions.innerHTML = items.map(function (item, index) {
        return (
          '<button type="button" class="og-delivery__suggestion" data-og-suggestion-index="' + index + '">' +
            '<span class="og-delivery__suggestion-title">' + escapeHtml(item.title || '') + '</span>' +
            '<span class="og-delivery__suggestion-meta">' + escapeHtml(item.meta || '') + '</span>' +
          '</button>'
        );
      }).join('');
      els.suggestions.hidden = false;
    }
    function getGoogleSuggestions(input, done) {
      if (!initGoogleServices() || !googleAutocompleteService) {
        done([]);
        return;
      }
      var token = ++googleRequestToken;
      googleAutocompleteService.getPlacePredictions({
        input: input,
        componentRestrictions: { country: config.googleCountry || 'in' },
        types: ['geocode'],
        sessionToken: googleSessionToken || undefined
      }, function (predictions, status) {
        if (token !== googleRequestToken) return;
        if (
          !predictions ||
          !predictions.length ||
          status !== google.maps.places.PlacesServiceStatus.OK
        ) {
          done([]);
          return;
        }
        done(predictions.slice(0, 8).map(function (p) {
          var title =
            p.structured_formatting && p.structured_formatting.main_text
              ? p.structured_formatting.main_text
              : p.description;
          var meta =
            p.structured_formatting && p.structured_formatting.secondary_text
              ? p.structured_formatting.secondary_text
              : p.description;
          return {
            source: 'google',
            title: title,
            meta: meta,
            placeId: p.place_id
          };
        }));
      });
    }
    function showCombinedSuggestions(input) {
      var value = String(input || '').trim();
      if (/^\d/.test(value)) {
        googleRequestToken++;
        renderSuggestions(getSheetSuggestions(value));
        return;
      }
      if (/^[a-zA-Z]/.test(value)) {
        renderSuggestions([]);
        getGoogleSuggestions(value, function (googleItems) {
          renderSuggestions(googleItems);
        });
        return;
      }
      renderSuggestions([]);
    }
     function chooseMatchedLocation(match, inputLabel, resolvedPin) {
  /*
   * Prevent delayed Google Places/location callbacks from overwriting
   * a delivery that has already been restored from storage.
   */
  if (
    restoredSelectionLocked &&
    !isEditingDeliverySelection &&
    isReady()
  ) {
    if (els.input) els.input.value = getLocationLabel();
    renderSummary();
    root.classList.add('is-summary-mode');
    if (els.summary) els.summary.hidden = false;
    return;
  }

  if (!match) {
    state.matchedLocation = null;
    state.selectedDate = '';
    state.selectedDateLabel = '';
    state.selectedType = '';
    state.selectedSlot = null;
    state.finalCharge = 0;
    state.finalChargeLabel = '';
    var unavailablePin =
      String(resolvedPin || extractPincode(inputLabel) || '').trim();
    if (els.input) {
      els.input.value = unavailablePin
        ? buildResolvedLocationLabel(
            unavailablePin,
            inputLabel || els.input.value || '',
            ''
          )
        : (inputLabel || els.input.value || '');
    }
    if (els.suggestions) {
      els.suggestions.hidden = true;
      els.suggestions.innerHTML = '';
    }
    if (els.flow) els.flow.hidden = true;
    if (els.summary) els.summary.hidden = true;
    applyProperties();
    toggleReset();
    try { sessionStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
    try { localStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
    setUnavailableMsg(unavailablePin);
    syncDeliveryFlowVisibility();
    return;
  }
  var resolvedDisplayLabel = buildResolvedLocationLabel(
    match.pincode,
    inputLabel || match.displayMeta || match.rawLocation,
    match.city
  );
  state.matchedLocation = Object.assign({}, match, {
    selectedDisplayLabel: resolvedDisplayLabel
  });
  match = state.matchedLocation;
  var min = getMinSelectableDate(match);
  state.selectedDate = ymd(min);
  state.selectedDateLabel = formatSelectedDateLabel(min);
  state.selectedType = '';
  state.selectedSlot = null;
  var options = availableTypesForLocation(match, state.selectedDate);
  if (options.length === 1) {
    state.selectedType = options[0].key;
  }
  if (els.input) {
    els.input.value = getLocationLabel();
  }
  if (els.suggestions) {
    els.suggestions.hidden = true;
    els.suggestions.innerHTML = '';
  }
  setMsg('Location found! We deliver to this area.', 'success');
  renderAll();
  saveSelection();
}
    function askForExactPincode(inputLabel) {
      if (
        restoredSelectionLocked &&
        !isEditingDeliverySelection &&
        isReady()
      ) {
        if (els.input) els.input.value = getLocationLabel();
        renderSummary();
        root.classList.add('is-summary-mode');
        if (els.summary) els.summary.hidden = false;
        return;
      }

      state.matchedLocation = null;
      state.selectedDate = '';
      state.selectedDateLabel = '';
      state.selectedType = '';
      state.selectedSlot = null;
      state.finalCharge = 0;
      state.finalChargeLabel = '';
      if (els.input) {
        els.input.value = inputLabel || els.input.value || '';
      }
      if (els.suggestions) {
        els.suggestions.hidden = true;
        els.suggestions.innerHTML = '';
      }
      if (els.summary) els.summary.hidden = true;
      applyProperties();
      toggleReset();
      try { sessionStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
      try { localStorage.removeItem(SELECTION_CACHE_KEY); } catch (e) {}
      setMsg('Please enter the receiver\'s exact 6-digit pincode to check delivery availability.', 'error');
      syncDeliveryFlowVisibility();
      renderDateOptions();
    }
    function extractPostalCodeFromComponents(components) {
      var pin = '';
      (components || []).some(function (component) {
        var types = component.types || [];
        if (types.indexOf('postal_code') > -1) {
          pin = String(component.long_name || component.short_name || '').trim();
          return true;
        }
        return false;
      });
      return /^\d{6}$/.test(pin) ? pin : '';
    }
    function reverseGeocodePincode(location, done) {
      if (!location || !googleGeocoder) {
        done('');
        return;
      }
      googleGeocoder.geocode({ location: location }, function (results, status) {
        if (
          status !== google.maps.GeocoderStatus.OK ||
          !results ||
          !results.length
        ) {
          done('');
          return;
        }
        var pin = '';
        for (var i = 0; i < results.length; i++) {
          pin = extractPostalCodeFromComponents(results[i].address_components || []);
          if (pin) break;
        }
        done(pin);
      });
    }
    function resolveGooglePlace(item) {
      var fallbackLabel = item.meta || item.title || '';
      if (!initGoogleServices() || !googlePlacesService) {
        var fallbackPin = extractPincode(fallbackLabel);
        if (fallbackPin) {
          chooseMatchedLocation(findByPincode(fallbackPin), fallbackLabel, fallbackPin);
        } else {
          askForExactPincode(fallbackLabel);
        }
        return;
      }
      googlePlacesService.getDetails({
        placeId: item.placeId,
        fields: ['address_components', 'formatted_address', 'name', 'geometry'],
        sessionToken: googleSessionToken || undefined
      }, function (place, status) {
        googleSessionToken = null;
        var label =
          (place && place.formatted_address) ||
          item.meta ||
          item.title ||
          '';
        if (
          status !== google.maps.places.PlacesServiceStatus.OK ||
          !place
        ) {
          var labelPin = extractPincode(label);
          if (labelPin) {
            chooseMatchedLocation(findByPincode(labelPin), label, labelPin);
          } else {
            askForExactPincode(label);
          }
          return;
        }
        var pin = extractPostalCodeFromComponents(place.address_components || []);
        if (!pin) {
          pin = extractPincode(label);
        }
        if (pin) {
          chooseMatchedLocation(findByPincode(pin), label, pin);
          return;
        }
        var location =
          place.geometry && place.geometry.location
            ? place.geometry.location
            : null;
        reverseGeocodePincode(location, function (reversePin) {
          if (reversePin) {
            chooseMatchedLocation(findByPincode(reversePin), label, reversePin);
          } else {
            askForExactPincode(label);
          }
        });
      });
    }
    function handleRawInputLookup() {
      if (
        restoredSelectionLocked &&
        !isEditingDeliverySelection &&
        isReady()
      ) {
        if (els.input) els.input.value = getLocationLabel();
        renderSummary();
        root.classList.add('is-summary-mode');
        if (els.summary) els.summary.hidden = false;
        return;
      }

      var value = els.input ? els.input.value.trim() : '';
      if (!value) return;
      var pin = extractPincode(value);
      if (!pin) {
        setMsg('Please enter or select an exact 6-digit pincode.', 'error');
        return;
      }
      var match = findByPincode(pin);
      if (match) {
        chooseMatchedLocation(
          match,
          buildReadableLocation([match.city, match.pincode]) || value
        );
      } else {
        chooseMatchedLocation(null, value, pin);
      }
    }
    function handleSubmit(e) {
      if (isUnavailableLocation()) {
        if (typeof window.__ogPrepareUnavailableNativeFlow === 'function') {
          window.__ogPrepareUnavailableNativeFlow();
        }
        return true;
      }
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
      if (isSubmitting) return false;
      if (!isReady()) {
        setMsg('Please select delivery location, date, delivery type and time slot.', 'error');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      var payload = getProductFormPayload();
      if (!payload) {
        setMsg('Product variant not found. Please select product option again.', 'error');
        return false;
      }
      isSubmitting = true;
      setMsg('Adding product with delivery details...', '');
      postCartAdd(payload)
        .then(function () {
          saveSelection();
          return syncFeeItemInCart();
        })
        .then(function () {
          dispatchCartRefresh();
          openCartUi();
          setMsg('Added to cart with delivery details.', 'success');
        })
        .catch(function (err) {
          console.error('[OG Delivery] Add failed', err);
          setMsg('Could not add to cart. Please try again.', 'error');
        })
        .finally(function () {
          isSubmitting = false;
        });
      return false;
    }
    function bindEvents() {
      if (els.input) {
        els.input.addEventListener('input', function (e) {
          var value = els.input.value.trim();

          /*
           * HARD CROSS-PRODUCT LOCK
           * -----------------------
           * After a completed delivery is restored, no input/autofill/
           * Google Places/theme event is allowed to clear it.
           *
           * The customer can intentionally unlock only with:
           * - Change button
           * - clear/reset button
           * - a date button (when visible)
           *
           * This prevents the exact bug where the saved summary appears
           * first, then a delayed input event wipes selectedType/slot and
           * paints the fresh delivery options.
           */
          if (
            restoredSelectionLocked &&
            !isEditingDeliverySelection &&
            isReady()
          ) {
            clearTimeout(suggestionTimer);
            activeSuggestions = [];
            if (els.suggestions) {
              els.suggestions.hidden = true;
              els.suggestions.innerHTML = '';
            }

            if (els.input) {
              els.input.value = getLocationLabel();
            }

            setMsg('Location found! We deliver to this area.', 'success');
            renderSummary();
            applyProperties();
            toggleReset();

            root.setAttribute('data-og-restored-lock', 'true');
            root.classList.add('is-summary-mode');

            if (els.summary) {
              els.summary.hidden = false;
            }
            return;
          }

          toggleReset();
          state.matchedLocation = null;
          state.selectedDate = '';
          state.selectedDateLabel = '';
          state.selectedType = '';
          state.selectedSlot = null;
          if (els.summary) els.summary.hidden = true;
          syncDeliveryFlowVisibility();
          renderDateOptions();
          applyProperties();
          clearTimeout(suggestionTimer);

          if (value.length < 2) {
            renderSuggestions([]);
            setMsg('', '');
            return;
          }

          setMsg('Searching delivery locations...', '');
          suggestionTimer = setTimeout(function () {
            showCombinedSuggestions(value);
          }, 120);
        });
        els.input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleRawInputLookup();
          }
        });
        els.input.addEventListener('blur', function () {
          setTimeout(function () {
            if (els.suggestions) els.suggestions.hidden = true;
          }, 180);
        });
        els.input.addEventListener('focus', function () {
          if (activeSuggestions.length && els.suggestions) {
            els.suggestions.hidden = false;
          }
        });
      }
      if (els.suggestions) {
        els.suggestions.addEventListener('mousedown', function (e) {
          e.preventDefault();
        });
        els.suggestions.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-og-suggestion-index]');
          if (!btn) return;
          var item = activeSuggestions[Number(btn.getAttribute('data-og-suggestion-index'))];
          if (!item) return;
          if (item.source === 'sheet') {
            var match = item.pincode
              ? findByPincode(item.pincode)
              : findByCity(item.city || item.title);
            chooseMatchedLocation(match, item.title, item.pincode || match.pincode);
          } else {
            resolveGooglePlace(item);
          }
        });
      }
      if (els.reset) {
        els.reset.addEventListener('click', function () {
          resetAll();
        });
      }
      if (els.dateOptions) {
        els.dateOptions.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-og-date]');
          if (!btn || btn.disabled) return;
          restoredSelectionLocked = false;
          root.removeAttribute('data-og-restored-lock');
          isEditingDeliverySelection = true;
          selectDateValue(btn.getAttribute('data-og-date'));
        });
      }
      if (els.typeOptions) {
        els.typeOptions.addEventListener('click', function (e) {
          var slotBtn = e.target.closest('[data-og-inline-slot-index]');
          if (slotBtn) {
            var slotType = slotBtn.getAttribute('data-og-inline-slot-type');
            if (!slotType) return;

            var inlineSlots = getFilteredSlotsForType(slotType, state.selectedDate);
            var inlineSlot = inlineSlots[Number(slotBtn.getAttribute('data-og-inline-slot-index'))];
            if (!inlineSlot) return;

            state.selectedType = slotType;
            state.selectedSlot = inlineSlot;
            isEditingDeliverySelection = false;
            renderAll();
            saveSelection();

            setTimeout(function () {
              if (els.summary) {
                els.summary.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }, 120);
            return;
          }

          var btn = e.target.closest('[data-og-type]');
          if (!btn) return;

          var typeKey = btn.getAttribute('data-og-type');
          var slots = getFilteredSlotsForType(typeKey, state.selectedDate);
          if (!slots.length) return;

          if (slots.length === 1) {
            state.selectedType = typeKey;
            state.selectedSlot = slots[0];
            isEditingDeliverySelection = false;
            renderAll();
            saveSelection();

            setTimeout(function () {
              if (els.summary) {
                els.summary.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }, 100);
            return;
          }

          if (state.selectedType === typeKey) {

            state.selectedType = '';
            state.selectedSlot = null;
            renderAll();
            return;
          }

          state.selectedType = typeKey;
          state.selectedSlot = null;
          isEditingDeliverySelection = true;
          renderAll();
        });
      }

      if (els.slotOptions) {
        els.slotOptions.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-og-slot-index]');
          if (!btn || !state.selectedType) return;

          var slots = getFilteredSlotsForType(state.selectedType, state.selectedDate);
          var slot = slots[Number(btn.getAttribute('data-og-slot-index'))];
          if (!slot) return;

          state.selectedSlot = slot;
          isEditingDeliverySelection = false;
          renderAll();
          saveSelection();

          setTimeout(function () {
            if (els.summary) {
              els.summary.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            }
          }, 120);
        });
      }
      if (els.modify) {
        els.modify.addEventListener('click', function () {
          restoredSelectionLocked = false;
          root.removeAttribute('data-og-restored-lock');
          isEditingDeliverySelection = true;
          renderAll();

          setTimeout(function () {
            if (els.dateOptions) {
              els.dateOptions.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            }
          }, 40);
        });
      }
      if (els.calendarOverlay) els.calendarOverlay.addEventListener('click', closeCalendar);
      if (els.calendarClose) els.calendarClose.addEventListener('click', closeCalendar);
      if (els.calendarPrev) {
        els.calendarPrev.addEventListener('click', function () {
          if (!state.calendarMonth) return;
          state.calendarMonth = new Date(
            state.calendarMonth.getFullYear(),
            state.calendarMonth.getMonth() - 1,
            1
          );
          renderCalendar();
        });
      }
      if (els.calendarNext) {
        els.calendarNext.addEventListener('click', function () {
          if (!state.calendarMonth) return;
          state.calendarMonth = new Date(
            state.calendarMonth.getFullYear(),
            state.calendarMonth.getMonth() + 1,
            1
          );
          renderCalendar();
        });
      }
      if (els.calendarDays) {
        els.calendarDays.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-og-calendar-date]');
          if (!btn || btn.disabled) return;
          selectDateValue(btn.getAttribute('data-og-calendar-date'));
        });
      }
      if (productForm) {
        productForm.addEventListener('submit', handleSubmit, true);
      }
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
        if (!root || !document.body.contains(root)) return;
        handleSubmit(e);
      }, true);
      document.addEventListener('click', function (e) {
  var btn = e.target.closest(
    'button[type="submit"], input[type="submit"], button[name="add"], .shopify-payment-button__button'
  );
  if (!btn) return;
  var form = btn.closest('form[action*="/cart/add"]');
  if (!form) return;
  if (!root || !document.body.contains(root)) return;
  if (!form.contains(root) && !root.contains(form) && form !== getCurrentProductForm()) {
    return;
  }
  if (isUnavailableLocation()) {
    if (typeof window.__ogPrepareUnavailableNativeFlow === 'function') {
      window.__ogPrepareUnavailableNativeFlow();
    }
    return;
  }
  if (!isReady()) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
    setMsg('Please select delivery location, date, delivery type and time slot.', 'error');
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') {
    e.stopImmediatePropagation();
  }
  handleSubmit(e);
  return false;
}, true);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          markFeeLinesInDom();
          if (!isEditingDeliverySelection && readSelectionCache()) {
            restoreSelection();
          } else {
            renderAll();
          }
        }
      });
      window.addEventListener('pageshow', function () {
        root.__ogSoftRestore();
      });
    }
    root.__ogSoftRestore = function () {
      bootSheetRows().then(function () {
        restoreSelection();
        markFeeLinesInDom();
      });
    };
    bootSheetRows().then(function () {
      bindEvents();
      if (!restoreSelection()) {
        renderAll();
      }
      toggleReset();
      markFeeLinesInDom();
    });
    var ogCartObserver = new MutationObserver(function () {
  markFeeLinesInDom();
});
ogCartObserver.observe(document.body, {
  childList: true,
  subtree: true
});
setTimeout(markFeeLinesInDom, 100);
setTimeout(markFeeLinesInDom, 500);
setTimeout(markFeeLinesInDom, 1200);
setTimeout(markFeeLinesInDom, 2500);
  }
  window.__initOgDeliveryCore = initOgDelivery;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOgDelivery);
  } else {
    initOgDelivery();
  }
document.addEventListener('click', function (e) {
  var btn = e.target.closest('button[type="submit"], .shopify-payment-button__button');
  if (!btn) return;
  var form = btn.closest('form[action*="/cart/add"]');
  if (!form) return;
  var oldText = btn.innerHTML;
  btn.innerHTML = '⏳ Adding...';
  btn.style.opacity = '0.75';
  btn.style.pointerEvents = 'none';
  setTimeout(function () {
    btn.innerHTML = oldText;
    btn.style.opacity = '';
    btn.style.pointerEvents = '';
  }, 2500);
});
  window.addEventListener('pageshow', initOgDelivery);
})();
(function () {
  'use strict';
  var checkoutInProgress = false;
  var savedMessageHtml = null;
  var savedMessageClass = null;
  var messageWasSuppressed = false;
  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }
  function isProductFormButton(element) {
    if (!element || !element.closest) return false;
    return !!element.closest(
      'form[action*="/cart/add"]'
    );
  }
  function isInsideDeliveryWidget(element) {
    if (!element || !element.closest) return false;
    return !!element.closest(
      '#og-delivery-widget'
    );
  }
  function getClickedElement(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      'button,' +
      'a,' +
      'input[type="submit"],' +
      'input[type="button"]'
    );
  }
  function getCheckoutButton(target) {
    if (!target || !target.closest) return null;
    var checkoutButton = target.closest(
      'a[href*="/checkout"],' +
      'button[name="checkout"],' +
      'input[name="checkout"],' +
      '[name="checkout"],' +
      '.cart__checkout-button,' +
      '.cart-drawer__checkout,' +
      '.checkout-button,' +
      '.cart-checkout,' +
      '[data-cart-checkout],' +
      '[data-checkout-button],' +
      '[data-testid="Checkout-button"]'
    );
    if (checkoutButton) {
      if (isProductFormButton(checkoutButton)) return null;
      if (isInsideDeliveryWidget(checkoutButton)) return null;
      return checkoutButton;
    }
    var genericButton = getClickedElement(target);
    if (!genericButton) return null;
    if (isProductFormButton(genericButton)) return null;
    if (isInsideDeliveryWidget(genericButton)) return null;
    var text = normalizeText(
      genericButton.textContent ||
      genericButton.value ||
      ''
    );
    var href = normalizeText(
      genericButton.getAttribute('href') || ''
    );
    var name = normalizeText(
      genericButton.getAttribute('name') || ''
    );
    var ariaLabel = normalizeText(
      genericButton.getAttribute('aria-label') || ''
    );
    var title = normalizeText(
      genericButton.getAttribute('title') || ''
    );
    var isCheckout =
      href.indexOf('/checkout') > -1 ||
      name === 'checkout' ||
      text === 'checkout' ||
      text === 'check out' ||
      text.indexOf('checkout') > -1 ||
      text.indexOf('check out') > -1 ||
      ariaLabel.indexOf('checkout') > -1 ||
      ariaLabel.indexOf('check out') > -1 ||
      title.indexOf('checkout') > -1 ||
      title.indexOf('check out') > -1;
    return isCheckout ? genericButton : null;
  }
  function suppressUnavailableMessage() {
    var message = document.getElementById(
      'ogInlineMessage'
    );
    if (!message) return;
    var text = normalizeText(
      message.textContent || ''
    );
    if (
      text.indexOf('delivery is not available') === -1 &&
      text.indexOf('this product cannot be delivered') === -1
    ) {
      return;
    }
    if (!messageWasSuppressed) {
      savedMessageHtml = message.innerHTML;
      savedMessageClass = message.className;
    }
    messageWasSuppressed = true;
    message.innerHTML =
      '<span data-og-checkout-temp-message="true">' +
      'Proceeding to checkout...' +
      '</span>';
    message.className =
      'og-delivery__inline-message';
  }
  function restoreUnavailableMessage() {
    if (!messageWasSuppressed) return;
    var message = document.getElementById(
      'ogInlineMessage'
    );
    if (message) {
      if (savedMessageHtml !== null) {
        message.innerHTML = savedMessageHtml;
      }
      if (savedMessageClass !== null) {
        message.className = savedMessageClass;
      }
    }
    savedMessageHtml = null;
    savedMessageClass = null;
    messageWasSuppressed = false;
  }
  function prepareCheckout(event) {
    var checkoutButton = getCheckoutButton(
      event.target
    );
    if (!checkoutButton) return;
    suppressUnavailableMessage();
  }
  function showCheckoutLoading(button) {
    if (!button) return;
    if (
      !button.hasAttribute(
        'data-og-checkout-old-html'
      )
    ) {
      button.setAttribute(
        'data-og-checkout-old-html',
        button.innerHTML || ''
      );
    }
    if (
      !button.hasAttribute(
        'data-og-checkout-old-value'
      )
    ) {
      button.setAttribute(
        'data-og-checkout-old-value',
        button.value || ''
      );
    }
    if (button.tagName === 'INPUT') {
      button.value = 'Redirecting...';
    } else {
      button.innerHTML = '⏳ Redirecting...';
    }
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.75';
    button.setAttribute('aria-disabled', 'true');
  }
  function restoreCheckoutButton(button) {
    if (!button) return;
    var oldHtml = button.getAttribute(
      'data-og-checkout-old-html'
    );
    var oldValue = button.getAttribute(
      'data-og-checkout-old-value'
    );
    if (
      button.tagName === 'INPUT' &&
      oldValue !== null
    ) {
      button.value = oldValue;
    } else if (oldHtml !== null) {
      button.innerHTML = oldHtml;
    }
    button.style.pointerEvents = '';
    button.style.opacity = '';
    button.removeAttribute('aria-disabled');
    button.removeAttribute(
      'data-og-checkout-old-html'
    );
    button.removeAttribute(
      'data-og-checkout-old-value'
    );
  }
  function redirectToCheckout(event) {
    var checkoutButton = getCheckoutButton(
      event.target
    );
    if (!checkoutButton) return;
    event.preventDefault();
    event.stopPropagation();
    if (
      typeof event.stopImmediatePropagation ===
      'function'
    ) {
      event.stopImmediatePropagation();
    }
    if (checkoutInProgress) {
      return false;
    }
    checkoutInProgress = true;
    suppressUnavailableMessage();
    showCheckoutLoading(checkoutButton);
    window.location.replace('/checkout');
    setTimeout(function () {
      checkoutInProgress = false;
      restoreCheckoutButton(checkoutButton);
      restoreUnavailableMessage();
    }, 4000);
    return false;
  }
  window.addEventListener(
    'pointerdown',
    prepareCheckout,
    true
  );
  window.addEventListener(
    'mousedown',
    prepareCheckout,
    true
  );
  window.addEventListener(
    'touchstart',
    prepareCheckout,
    true
  );
  window.addEventListener(
    'click',
    redirectToCheckout,
    true
  );
  window.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return;
      }
      var checkoutButton = getCheckoutButton(
        event.target
      );
      if (!checkoutButton) return;
      suppressUnavailableMessage();
    },
    true
  );
  window.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (
        form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }
      var submitter = event.submitter || null;
      var checkoutButton = submitter
        ? getCheckoutButton(submitter)
        : null;
      var action = normalizeText(
        form.getAttribute('action') || ''
      );
      var isCheckoutSubmit =
        !!checkoutButton ||
        action.indexOf('/checkout') > -1;
      if (!isCheckoutSubmit) return;
      event.preventDefault();
      event.stopPropagation();
      if (
        typeof event.stopImmediatePropagation ===
        'function'
      ) {
        event.stopImmediatePropagation();
      }
      if (checkoutInProgress) return false;
      checkoutInProgress = true;
      suppressUnavailableMessage();
      if (submitter) {
        showCheckoutLoading(submitter);
      }
      window.location.replace('/checkout');
      return false;
    },
    true
  );
  window.addEventListener(
    'pageshow',
    function () {
      checkoutInProgress = false;
      restoreUnavailableMessage();
      document.querySelectorAll(
        '[data-og-checkout-old-html],' +
        '[data-og-checkout-old-value]'
      ).forEach(function (button) {
        restoreCheckoutButton(button);
      });
    }
  );
})();